<template>
  <li class="column is-6">
    <router-link class="column" :to="{ name: 'Page', params: { pageId: page.slug, topicId: topic.slug }}">
      <span>{{ pageTitle }}</span>
      {{ pageSummary }}
    </router-link>
  </li>
</template>

<script>
  export default {
    name: 'PageTile',
    pageId: null,
    topicId:null,

    props: {
      page: {
        required: true,
        type: Object
      },
      topic: {
        required: true,
        type: Object
      }
    },
    created (){
        // console.log( 'P---->'+JSON.stringify(this.page ))
        // console.log( 'C---->'+JSON.stringify(this.topic ))
    },
    computed: {
      pageTitle () {
        return this.page.title
      },
      pageSummary () {
        return this.page.excerpt
      }
    }
  }
</script>
